// polyfills for IE
import 'core-js/fn/symbol';
import 'core-js/fn/symbol/iterator';

import React from 'react';

class DetailTabs extends React.Component {
  constructor(props) {
    super();
    this.state = {
      details: {},  // the complete set of details with lookup key
      variants: {}, // the variants that have detail lookups in order
      visible_keys: [],  // the ordered set of tabs currently displayed
      selected_key: null, // the current selected tab
      loaded: false
    };

    var self = this;
    var initial = null;
    props.app.bind('DATA_LOADED', function(data) {
      self.load(data);
      if (initial) {
        self.setDetails(initial);
      }
    });

    props.app.bind('VARIANT_CHANGED', function(identity) {
      if (!self.state.loaded) {
        initial = identity;
      } else {
        self.setDetails(identity);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onUpdated && this.state.selected_key) {
      this.props.onUpdated();
    }
  }

  // Images is an object with {image_key: image_object} pairs
  load(data) {
    data.loaded = true;
    this.setState(data);
  }

  setDetails(identity) {
    if (identity in this.state.variants) {
      let keys = [];
      for (let key of this.state.variants[identity].details) {
        if (key in this.state.details) {
          keys.push(key);
        }
      }

      // lookup the existing selected_key and see whether we can set a tab with the same slug
      let selected_key = this.state.selected_key;
      if (selected_key) {
        let detail = this.state.details[selected_key];
        selected_key = null;
        for (let key of keys) {
          if (this.state.details[key].slug === detail.slug) {
            selected_key = key;
            break;
          }
        }
      }

      this.setState({
        visible_keys: keys,
        selected_key: selected_key || (keys ? keys[0] : null)
      });
    } else {
      this.setState({
        visible_keys: [],
        selected_key: null
      });
    }
  }

  // Overriding default shouldComponentUpdate method to explicitly disable update when selected_key changes
  // since bootstrap will be handling the transition, not react
  shouldComponentUpdate(prevProps, prevState) {
    let shouldUpdate = false;
    for (let p in prevProps) {
      shouldUpdate = shouldUpdate || this.props[p] !== prevProps[p];
    }

    if (!shouldUpdate) {
      for (let s in prevState) {
        shouldUpdate = shouldUpdate || (s != 'selected_key' && this.state[s] !== prevState[s]);
      }
    }

    return shouldUpdate;
  }

  onTabClick(key) {
    // keep selected_key in sync so variant change can select the same slug, but don't re-render the component
    // since bootstrap will manage the transition (see shouldComponentUpdate)
    this.setState({
      selected_key: key
    });
  }

  getTabId(key) {
    return this.getTabContentId(key) + '-tab';
  }

  getTabContentId(key) {
    // https://stackoverflow.com/a/4579228
    let detail = this.state.details[key];
    return (String(key).lastIndexOf(detail.slug, 0) === 0 ? '' : detail.slug + '-') + key;
  }

  renderTab(key) {
    let detail = this.state.details[key];
    let selected = key === this.state.selected_key;
    let className = (selected ? 'active' : '');
    let tabId = this.getTabId(key);
    let contentId = this.getTabContentId(key);

    // http://a11yideas.com/testcode/tabs/tabs_with_ARIA.html
    // should include aria-selected={selected} on <a> but we're leaving the updates to bootstrap which doesn't honour it
    return (
      <li key={tabId} role="presentation" className={className}>
        <a id={tabId} aria-expanded={selected} aria-controls={contentId} href={'#' + contentId} data-toggle="tab" role="tab" onClick={() => this.onTabClick(key)}>
          {detail.name}
        </a>
      </li>
    );
  }

  renderTabContent(key) {
    let detail = this.state.details[key];
    let selected = key === this.state.selected_key;
    let className = `tab-pane fade detail-${detail.slug}` + (selected ? ' active in' : '');
    let tabId = this.getTabId(key);
    let contentId = this.getTabContentId(key);
    return (
      <div key={contentId} aria-labelledby={tabId} className={className} id={contentId}>
        <div className={this.props.containerClass} dangerouslySetInnerHTML={{ __html: detail.html }}></div>
      </div>
    );
  }

  render() {
    let tabs = this.state.visible_keys.map(key => this.renderTab(key));
    let contents = this.state.visible_keys.map(key => this.renderTabContent(key));

    if (tabs.length === 0)
      return null;

    return (
      <div>
        <div className="tab-header">
          <div className={this.props.containerClass}>
            <ul className="nav nav-tabs" role="tablist">
              {tabs}
            </ul>
          </div>
        </div>
        <div className="tab-content">
          {contents}
        </div>
      </div>
    );
  }
}

export {
  DetailTabs as default
}


// WEBPACK FOOTER //
// ./js/products/detail-tabs.jsx